import { constants } from "../utils";
import { useMediaQuery } from "react-responsive";

const BREAKPOINTS = constants.BREAKPOINTS;

export default function useBreakpoints() {
    const isMobile = useMediaQuery({ maxWidth: BREAKPOINTS.mobile });
    const isMobileLandscape = useMediaQuery({ minWidth: BREAKPOINTS.mobileLandscape, maxWidth: BREAKPOINTS.smallDesktop - 1 });
    const isSmallDesktop = useMediaQuery({ minWidth: BREAKPOINTS.smallDesktop, maxWidth: BREAKPOINTS.tablet - 1 });
    const isTablet = useMediaQuery({ minWidth: BREAKPOINTS.tablet, maxWidth: BREAKPOINTS.tabletLandscape - 1 });
    const isTabletLandscape = useMediaQuery({ minWidth: BREAKPOINTS.tabletLandscape, maxWidth: BREAKPOINTS.desktop - 1 });
    const isDesktop = useMediaQuery({ minWidth: BREAKPOINTS.desktop, maxWidth: BREAKPOINTS.desktopLarge - 1 });
    const isDesktopLarge = useMediaQuery({ minWidth: BREAKPOINTS.desktopLarge, maxWidth: BREAKPOINTS.desktopWide - 1 });
    const isDesktopWide = useMediaQuery({ minWidth: BREAKPOINTS.desktopWide });

    return {
        isMobile,
        isMobileLandscape,
        isSmallDesktop,
        isTablet,
        isTabletLandscape,
        isDesktop,
        isDesktopLarge,
        isDesktopWide
    }
};